import { render, staticRenderFns } from "./ChemMcMA4_ResultsV2.vue?vue&type=template&id=edf393c2&scoped=true&"
import script from "./ChemMcMA4_ResultsV2.vue?vue&type=script&lang=js&"
export * from "./ChemMcMA4_ResultsV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf393c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VFileInput,VForm,VSimpleTable})
